angular.module('SpidApp')

.factory('MoneyTransferService',
         ['MoneyTransfer', 'Restangular',
 function (MoneyTransfer,   Restangular) {
    var MoneyTransferService = {
        save: function (agencyId, moneyTransfer) {
            if (agencyId === undefined || agencyId === null || !moneyTransfer) {
                throw 'MoneyTransfer::save() - Missing parameter'
            }
            
            if (moneyTransfer.id === undefined || moneyTransfer === null) {
                return this._create(agencyId, moneyTransfer)
            } else {
                return this._update(agencyId, moneyTransfer)
            }
        },
        
        _create: function (agencyId, moneyTransfer) {
            if (!moneyTransfer) {
                throw 'MoneyTransfer::_create() - Missing parameter'
            }
            
            return Restangular.one('agencies', agencyId).all('money-transfers').post(moneyTransfer)
        },
        
        _update: function (agencyId, moneyTransfer) {
            if (!moneyTransfer) {
                throw 'MoneyTransfer::_update() - Missing parameter'
            }
            
            return Restangular.one('agencies', agencyId).one('money-transfers', moneyTransfer.id).post(moneyTransfer)
        },
        
        findByAgencyId : function (agencyId) {
            if (agencyId === undefined || agencyId === null ) {
                throw 'MoneyTransfer::findByAgencyId() - Missing parameter'
            }
            
            return Restangular.one('agencies', agencyId).all('money-transfers').getList().then(function (moneyTransferList){
            	return moneyTransferList.map(function (moneyTransfer){
            		return new MoneyTransfer(moneyTransfer)
            	})
            })
        },
        
        transferToDrawer: function(agencyId, userId, amount) {
        	if (!agencyId || !userId || (typeof(+amount) !== 'number')) {
                throw 'MoneyTransfer::transferToDrawer() - Missing parameter'
            }
        	
        	var currentAmount = 0
        	return MoneyTransferService.findByAgencyId(agencyId).then(function (listeMoneyTransfer){
        		var lastElemListeMoneyTransfer =  _.chain(listeMoneyTransfer).sortBy('updated_at').last().value()
        		if(lastElemListeMoneyTransfer !== null && _.size(lastElemListeMoneyTransfer) > 0){
            		currentAmount = lastElemListeMoneyTransfer.current
        		}
        	}).then(function() {
        		var moneyTransfer = new MoneyTransfer({
	                  from        : MoneyTransfer.sources.SAFE
	                , to          : MoneyTransfer.sources.DRAWER
	                , amount      : amount
	                , destination : 'Ouverture de vacation'
	                , current	  : +currentAmount - +amount
	                , agency_id   : agencyId
	                , user_id     : userId
	            })
        		
        		return MoneyTransferService.save(agencyId, moneyTransfer)
        	})
        },
        
        transferFromDrawer: function(agencyId, userId, amount) {
        	if (!agencyId || !userId || typeof(amount) !== 'number') {
                throw 'MoneyTransfer::transferFromDrawer() - Missing parameter'
            }
        	
        	var currentAmount = 0
        	return MoneyTransferService.findByAgencyId(agencyId).then(function (listeMoneyTransfer){
        		var lastElemListeMoneyTransfer =  _.chain(listeMoneyTransfer).sortBy('updated_at').last().value()
        		if(lastElemListeMoneyTransfer !== null && _.size(lastElemListeMoneyTransfer) > 0){
            		currentAmount = lastElemListeMoneyTransfer.current
        		}
        	}).then(function() {
        		var moneyTransfer = new MoneyTransfer({
	                  from        : MoneyTransfer.sources.DRAWER
	                , to          : MoneyTransfer.sources.SAFE
	                , amount      : amount
	                , destination : 'Fermeture de vacation'
	                , current	  : +currentAmount + (+amount)
	                , agency_id   : agencyId
	                , user_id     : userId
	            })
        		
        		return MoneyTransferService.save(agencyId, moneyTransfer)
        	})
        }
    }
    
    return MoneyTransferService
}])